export default function formatINR(amount: number) {
    return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2 // This is optional, for up to 2 decimal places if needed
    }).format(amount);
}
